import { render, staticRenderFns } from "./reserveTime.vue?vue&type=template&id=485a0708&scoped=true"
import script from "./reserveTime.vue?vue&type=script&lang=js"
export * from "./reserveTime.vue?vue&type=script&lang=js"
import style0 from "./reserveTime.vue?vue&type=style&index=0&id=485a0708&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a0708",
  null
  
)

export default component.exports